<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_user.validate_id_title')">
    <template #content>
      <v-container class="add-user">
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_user.name_en')"
                          :value="user.surname_en + ', ' + user.given_name_en"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_user.name_zh')"
                          :value="user.surname_zh + user.given_name_zh"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_user.company')"
                          :value="user.company ? user.company.name : ''"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_user.id_type')"
                          :value="{
                            1: 'ARA Permit',
                            2: 'Airport Octopus Card',
                            3: 'Company Card',
                            4: 'Personal Octopus Card + Company Staff Card / ARA Permit',
                          }[user.id_type]"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_user.id_no')"
                          :value="user.id_no"></v-text-field>
          </v-col>
        </v-row>
<!--        <v-row>-->
<!--          <v-col>-->
<!--            <v-text-field readonly-->
<!--                          :label="$t('admin_user.id_expiry_date')"-->
<!--                          :value="user.id_expiry_date"></v-text-field>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <v-row>
          <v-col>
            <v-input>
              <v-container fluid class="flex-column pa-0">
                <legend class="v-label theme--light">{{ $t('id_verification.front') }}</legend>
                <v-img contain
                       :src="getURL(user.octopus_front)"
                       max-height="300px"></v-img>
              </v-container>
            </v-input>
          </v-col>
          <v-col>
            <v-input>
              <v-container fluid class="flex-column pa-0">
                <legend class="v-label theme--light">{{ $t('id_verification.back') }}</legend>
                <v-img contain
                       :src="getURL(user.octopus_back)"
                       max-height="300px"></v-img>
              </v-container>
            </v-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-input>
              <v-container fluid class="flex-column pa-0">
                <legend class="v-label theme--light">{{ $t('id_verification.front') }}</legend>
                <v-img contain
                       :src="getURL(user.id_front)"
                       max-height="300px"></v-img>
              </v-container>
            </v-input>
          </v-col>
          <v-col>
            <v-input>
              <v-container fluid class="flex-column pa-0">
                <legend class="v-label theme--light">{{ $t('id_verification.back') }}</legend>
                <v-img contain
                       :src="getURL(user.id_back)"
                       max-height="300px"></v-img>
              </v-container>
            </v-input>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="danger"
               class="ml-4"
               depressed
               large
               @click="verifyUser(false)">
          {{ $t('admin_user.reject') }}
        </v-btn>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               @click="verifyUser(true, true)">
          {{ $t('admin_user.accept_with_gift') }}
        </v-btn>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               @click="verifyUser(true, false)">
          {{ $t('admin_user.accept_without_gift') }}
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import {ref, watch} from '@vue/composition-api';
import BGModal from "@/components/BGModal";

export default {
  name: 'ValidateMemberModal',
  components: {BGModal},
  props: {
    shown: Boolean,
    accountId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getUser();
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    }

    // Form
    const user = ref({});
    const getUser = function () {
      root.$callAPI('hkiarace/admin/user/', {id: props.accountId}, function (response) {
        user.value = response.body.user;
      });
    };


    const verifyUser = function (decision, with_gift) {
      if (decision && !confirm(root.$t('admin_user.confirm_accept_msg'))) {
        return;
      }

      if (!decision && !confirm(root.$t('admin_user.confirm_reject_msg'))) {
        return;
      }

      root.$callAPI('hkiarace/admin/user/verify_id/', {
        id: props.accountId, decision: decision, with_gift: with_gift
      }, () => {
        emit('finish');
      })
    }

    return {
      dialogShown,
      cancel,

      getURL,

      user,

      verifyUser
    }
  },
}
</script>

<style lang="less">
.add-user {

}
</style>
